import { useState } from 'react';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import {
  AppBar, Box, Button, Container, IconButton, Menu, MenuItem, Toolbar, Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import BaseLayout from './BaseLayout';
import ComplianceFooter from '../components/shared/ComplianceFooter';
import { useBranding } from '../theme/brandingContext';

const NAV_ITEMS = [
  { label: 'Apply', path: '/apply' },
  { label: 'Check Status', path: '/status' },
];

const PublicShell = () => {
  const { branding, logoUrl } = useBranding();
  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const companyName = branding?.companyName || 'United Fidelity Funding';

  return (
    <BaseLayout>
      <AppBar position="sticky" color="inherit" enableColorOnDark sx={{ bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ gap: 1 }}>
            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: { xs: 'none', md: 'flex' },
                alignItems: 'center',
                mr: 2,
                textDecoration: 'none',
              }}
            >
              <Box
                component="img"
                src={logoUrl}
                alt={companyName}
                sx={{ height: 44, width: 'auto', maxWidth: 220, objectFit: 'contain' }}
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="navigation menu"
                aria-controls="public-nav-menu"
                aria-haspopup="true"
                onClick={(e) => setAnchorElNav(e.currentTarget)}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="public-nav-menu"
                anchorEl={anchorElNav}
                open={Boolean(anchorElNav)}
                onClose={() => setAnchorElNav(null)}
                disableScrollLock
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                {NAV_ITEMS.map(({ label, path }) => (
                  <MenuItem
                    key={path}
                    component={RouterLink}
                    to={path}
                    selected={location.pathname.startsWith(path)}
                    onClick={() => setAnchorElNav(null)}
                  >
                    <Typography textAlign="center">{label}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                alignItems: 'center',
                textDecoration: 'none',
              }}
            >
              <Box
                component="img"
                src={logoUrl}
                alt={companyName}
                sx={{ height: 36, width: 'auto', maxWidth: 180, objectFit: 'contain' }}
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
              {NAV_ITEMS.map(({ label, path }) => {
                const active = location.pathname.startsWith(path);
                return (
                  <Button
                    key={path}
                    component={RouterLink}
                    to={path}
                    color={active ? 'primary' : 'inherit'}
                    sx={{ fontWeight: active ? 700 : 600 }}
                  >
                    {label}
                  </Button>
                );
              })}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>

      <ComplianceFooter
        companyName={branding?.companyName}
        nmlsId={branding?.nmlsId}
        contactPhone={branding?.contactPhone}
      />
    </BaseLayout>
  );
};

export default PublicShell;
